import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import AboutPage from "../pages/about/page";
import ServicesPage from "../pages/services/page";
import LoginPage from "../pages/login/page";
import PanelLayout from "../pages/panel/layout";
import HayvanlarPage from "../pages/panel/hayvanlar/page";
import HayvanDetayPage from "../pages/panel/hayvanlar/detay/page";
import MusterilerPage from "../pages/panel/musteriler/page";
import MusteriDetayPage from "../pages/panel/musteriler/detay/page";
import OdemeAlPage from "../pages/panel/odeme-al/page";
import OdemelerPage from "../pages/panel/odemeler/page";
import KesimPlanlamaPage from "../pages/panel/kesim-planlama/page";
import KesimAlaniPage from "../pages/panel/kesim-alani/page";
import TasimaPage from "../pages/panel/tasima/page";
import TasiyiciTasimaPage from "../pages/panel/tasiyici-tasima/page";
import TvEkraniPage from "../pages/panel/tv-ekrani/page";
import TamamlananPage from "../pages/panel/tamamlanan/page";
import KullaniciYonetimiPage from "../pages/panel/kullanici-yonetimi/page";
import SmsAyarlariPage from "../pages/panel/sms-ayarlari/page";
import SmsMusteriPage from "../pages/panel/sms-musteri/page";
import GelirGiderPage from "../pages/panel/gelir-gider/page";
import MusteriPaneliPage from "../pages/musteri-panel/page";
import SifreDegistirPage from "../pages/sifre-degistir/page";
import RaporlarPage from "../pages/panel/raporlar/page";
import SatislarPage from "../pages/panel/satislar/page";
import HavalePage from "../pages/panel/havale/page";
import HavaleTvPage from "../pages/panel/havale-tv/page";
import StokPage from "../pages/panel/stok/page";
import LoglarPage from "../pages/panel/loglar/page";
import SiteYonetimiPage from "../pages/panel/site-yonetimi/page";
import IstasyonSiraPage from "../pages/panel/istasyon/sira/page";
import IstasyonKesimPage from "../pages/panel/istasyon/kesim/page";
import IstasyonParcalamaPage from "../pages/panel/istasyon/parcalama/page";
import IstasyonTamamlamaPage from "../pages/panel/istasyon/tamamlama/page";
import HisseSatislariPage from "../pages/panel/hisse-satislari/page";

const routes: RouteObject[] = [
  { path: "/", element: <Home /> },
  { path: "/bizim", element: <AboutPage /> },
  { path: "/hizmetler", element: <ServicesPage /> },
  { path: "/giris", element: <LoginPage /> },
  { path: "/sifre-degistir", element: <SifreDegistirPage /> },

  {
    path: "/panel",
    element: <PanelLayout />,
    children: [
      { path: "hayvanlar", element: <HayvanlarPage /> },
      { path: "hayvanlar/:id", element: <HayvanDetayPage /> },
      { path: "musteriler", element: <MusterilerPage /> },
      { path: "satislar", element: <SatislarPage /> },
      { path: "hisse-satislari", element: <HisseSatislariPage /> },
      { path: "musteriler/:id", element: <MusteriDetayPage /> },
      { path: "odeme-al", element: <OdemeAlPage /> },
      { path: "odemeler", element: <OdemelerPage /> },
      { path: "havale", element: <HavalePage /> },
      { path: "kesim-planlama", element: <KesimPlanlamaPage /> },
      { path: "tasima", element: <TasimaPage /> },
      { path: "tamamlanan", element: <TamamlananPage /> },
      { path: "gelir-gider", element: <GelirGiderPage /> },
      { path: "stok", element: <StokPage /> },
      { path: "kullanici-yonetimi", element: <KullaniciYonetimiPage /> },
      { path: "sms-ayarlari", element: <SmsAyarlariPage /> },
      { path: "sms-musteri", element: <SmsMusteriPage /> },
      { path: "raporlar", element: <RaporlarPage /> },
      { path: "loglar", element: <LoglarPage /> },
      { path: "site-yonetimi", element: <SiteYonetimiPage /> },
    ],
  },

  { path: "/panel/kesim-alani", element: <KesimAlaniPage /> },
  { path: "/panel/tasiyici-tasima", element: <TasiyiciTasimaPage /> },
  { path: "/panel/tv-ekrani", element: <TvEkraniPage /> },
  { path: "/panel/havale-tv", element: <HavaleTvPage /> },
  { path: "/panel/istasyon/sira", element: <IstasyonSiraPage /> },
  { path: "/panel/istasyon/kesim", element: <IstasyonKesimPage /> },
  { path: "/panel/istasyon/parcalama", element: <IstasyonParcalamaPage /> },
  { path: "/panel/istasyon/tamamlama", element: <IstasyonTamamlamaPage /> },

  { path: "/musteri-panel", element: <MusteriPaneliPage /> },
  { path: "*", element: <NotFound /> },
];

export default routes;